import { useEffect } from "react";
import { STORE } from "../../../data/storeData";
import { PRICE_RANGE } from "../../../data/menuData";

// 構造化データ（JSON-LD）をSTORE/menuDataから自動生成して<head>に挿入する。
// 店舗情報を複数箇所にハードコードしないよう、storeData.ts / menuData.ts を単一の情報源として利用。
export default function Seo() {
  useEffect(() => {
    const data: Record<string, unknown> = {
      "@context": "https://schema.org",
      "@type": "Restaurant",
      name: STORE.storeName,
      alternateName: STORE.brandName,
      image: `${STORE.siteUrl}og-image.jpg`,
      servesCuisine: "カレー",
      priceRange: `¥${PRICE_RANGE.curryMin}〜¥${PRICE_RANGE.curryMax}`,
      telephone: STORE.phone ?? undefined,
      address: {
        "@type": "PostalAddress",
        streetAddress: STORE.address,
        addressLocality: "神戸市中央区",
        addressRegion: "兵庫県",
        postalCode: STORE.postalCode.replace("〒", ""),
        addressCountry: "JP",
      },
      openingHoursSpecification: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
        opens: STORE.hoursOpen,
        closes: STORE.hoursClose,
      },
      url: STORE.siteUrl,
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(data);
    script.id = "ld-json-restaurant";

    const existing = document.getElementById("ld-json-restaurant");
    if (existing) existing.remove();
    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  return null;
}
